import { ChangeDetectionStrategy, Component } from '@angular/core'
import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'unauthenticated',
  imports: [TranslatePipe],
  template: `<p>{{ 'APP.UNAUTHENTICATED' | translate }}</p>`,
  styleUrl: './unauthenticated.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnauthenticatedComponent {}
